







import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import moment from 'moment/moment';

@Component
export default class TimeStats extends Vue {

  private get t(): number {
    return store.state.MissionAnimation.t;
  }

  private get formattedDate(): string {
    return moment(store.getters['MissionAnimation/tDate']).format("YYYY-MM-DD");
  }

}
